const Note = '4ff4a23e-ed82-11ea-9e21-024ef06a0f02'
const TimeNote = '5a4bda6c-ed82-11ea-9e21-024ef06a0f02'

export { Note, TimeNote }